import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  static targets = ['rejectionReason', 'acceptButton', 'rejectButton', 'spotCheckButton', 'hidden']

  declare rejectionReasonTarget: HTMLTextAreaElement
  declare acceptButtonTarget: HTMLButtonElement
  declare rejectButtonTarget: HTMLButtonElement
  declare spotCheckButtonTarget: HTMLButtonElement
  declare hiddenTarget: HTMLInputElement

  declare form: HTMLFormElement | null

  connect(): void {
    const spotCheckConfirmation = this.spotCheckButtonTarget.nextElementSibling
    const spotCheckButtons = spotCheckConfirmation?.querySelectorAll('button')
    const spotCheckConfirmButton = spotCheckButtons?.[2] as HTMLButtonElement

    spotCheckConfirmButton.addEventListener('click', () => {
      this.#sendResult('spotcheck')
    })

    this.form = this.hiddenTarget.form
  }

  #sendResult(result: string): void {
    if (this.form === null) return

    this.hiddenTarget.value = result
    this.form.submit()
  }

  #addGeneralRejectionReason(reason: string): void {
    if (this.rejectionReasonTarget.value.length > 0) {
      this.rejectionReasonTarget.value += `\n${reason}`
    } else {
      this.rejectionReasonTarget.value = reason
    }
    this.rejectButtonTarget.disabled = false
    this.acceptButtonTarget.disabled = true
    this.spotCheckButtonTarget.disabled = false
  }

  clickAccept(): void {
    this.#sendResult('accept')
  }

  clickReject(): void {
    this.#sendResult('reject')
  }

  changeRejectionReasonText(): void {
    const isEmpty = this.rejectionReasonTarget.value.length === 0
    this.rejectButtonTarget.disabled = isEmpty
    this.acceptButtonTarget.disabled = !isEmpty
    this.spotCheckButtonTarget.disabled = isEmpty
  }

  clickGeneralRejectionReasonButton({ params: { reason } }: { params: { reason: string } }): void {
    this.#addGeneralRejectionReason(reason)
  }

  changeProductRejectionReason(e: InputEvent): void {
    const select = e.currentTarget as HTMLSelectElement
    const counter = select.dataset.counter ?? '0'
    const reason = select.value
    const formattedReason = `${counter}. ${reason}`
    this.#addGeneralRejectionReason(formattedReason)
  }
}
